import React from "react";
import { Alert, Button } from "react-bootstrap";

const Alerts = ({ title, content, buttonContent, show, setShow, variant }) => {
  //   const [show, setShow] = useState(false);
  return (
    <>
      <Alert show={show} variant={variant}>
        <Alert.Heading className="text-center"> {title} </Alert.Heading>
        <div>{content}</div>
        <hr />
        <div className="d-flex justify-content-end">
          {buttonContent ? (
            <Button
              onClick={() => setShow(false)}
              variant={
                variant == "success"
                  ? "outline-success"
                  : variant == "danger"
                  ? "outline-danger"
                  : "outline-primary"
              }
            >
              {buttonContent}
            </Button>
          ) : null}
        </div>
      </Alert>
    </>
  );
};

export default Alerts;
